import React from 'react';
import { useAgreementTemplateQuery } from '@uplift/queries';
import { CollaborativeAgreementSigned } from '@uplift/api';
import { Draw } from '@mui/icons-material';
import { DocumentListItemRow } from './DocumentListItemRow';


export const CollaborativeAgreementCounterSignatureRequiredListItem: React.VFC<{
  document: CollaborativeAgreementSigned;
  onClick: () => void;
  selected: boolean;
}> = ({
  document,
  onClick,
  selected,
}) => {
  const { data: template } = useAgreementTemplateQuery(document.agreementTemplateId);

  return (
    <DocumentListItemRow
      name={template.name}
      status="Needs your counter-signature"
      statusColor="error"
      icon={<Draw />}
      onClick={onClick}
      selected={selected}
    />
  );
};
